import { Button } from "@heroui/react";
import { type AdminEpisodeDetail, ProductionState, type StoryGraphIssue } from "@storyline/shared";
import EpisodeGraphCanvas from "@/src/stories/components/graph/episode-graph-canvas";
import GraphSidePanel from "@/src/stories/components/graph/graph-side-panel";

type GraphStepProps = {
	episode: AdminEpisodeDetail;
	issues: StoryGraphIssue[];
	transitionError: string | null;
	onTransition: (to: ProductionState) => void;
};

const GraphStep: React.FC<GraphStepProps> = ({ episode, issues, transitionError, onTransition }) => (
	<div className="flex flex-col gap-4">
		{transitionError ? <p className="rounded-lg border border-danger/40 bg-glass p-3 text-danger text-sm">{transitionError}</p> : null}
		<div className="flex flex-col gap-4 lg:flex-row">
			<div className="min-w-0 flex-1">
				<EpisodeGraphCanvas episode={episode} issues={issues} />
			</div>
			<div className="w-full lg:w-80">
				<GraphSidePanel episode={episode} issues={issues} />
			</div>
		</div>
		<div className="flex justify-end">
			<Button onPress={() => onTransition(ProductionState.REFERENCES_REVIEW)}>Valider l'histoire → Références</Button>
		</div>
	</div>
);

export default GraphStep;
